@if (file(); as file) {
    @if (useFileSize()) {
        <div class="items-center flex max-w-[250px] justify-between pl-2 pr-3 py-1.5 border rounded-lg">
            <div class="flex items-center gap-3">
                <app-icon-button (click)="filsDownloadService.downloadFile(file)" icon="ic:outline-file-download" class="text-primary" />
                <p class="font-medium text-gray-800 line-clamp-1 max-w-24">{{ file.name }}</p>
                <p class="text-sm text-gray-400 whitespace-nowrap">({{ file.size | fileSize }})</p>
            </div>
        </div>
    } @else {
        <button (click)="filsDownloadService.downloadFile(file)" class="flex items-center gap-2 px-3 py-2 border max-w-64 rounded-3xl">
            <div class="flex items-center">
                <app-icon class="text-gray-400" name="material-symbols:file-copy-rounded"></app-icon>
            </div>
            <p class="font-medium text-gray-800 line-clamp-1 max-w-24">{{ file.name }}</p>
            <p class="text-sm font-semibold text-gray-800 line-clamp-1">({{ file.size | fileSize }})</p>
        </button>
    }
}
